<template>
  <div
    ref="frisbuy-widget-gallery"
    :class="{
      'frisbuy-widget': true,
      'frisbuy-vertical': isVerticalGallery,
      [`frisbuy-layout-${gallerySettings.layout}`]: gallerySettings.layout,
      [`frisbuy-${settings.customerCode}`]: true,
    }"
    :style="[galleryStyle]"
  >
    <!-- <script src="https://connect.facebook.net/en_US/all.js" async="" type="application/javascript" v-if="settings.popup.shareButtons.fb"></script> -->
    <div class="frisbuy-header">
      <div
        class="frisbuy-title"
        v-if="headerSettings.title || headerSettings.buttonTitle"
      >
        {{ headerSettings.title }}

        <a v-if="headerSettings.buttonTitle" :href="headerSettings.buttonLink">
          {{ headerSettings.buttonTitle }}
        </a>
      </div>

      <div v-if="headerSettings.subTitle" class="frisbuy-subtitle">
        {{ headerSettings.subTitle }}
      </div>
      <div v-if="headerSettings.html" v-html="headerSettings.html"></div>
    </div>
    <div class="frisbuy-categories" v-if="gallerySettings.filters.params">
      <a
        v-for="(filter, index) in gallerySettings.filters.params"
        :key="index"
        :href="`#tag=${filter.value ? filter.name : 'Все'}`"
        :class="{
          'frisbuy-category': true,
          'frisbuy-active':
            filterValue == filter.value ||
            (filterValue == null && !filter.value),
        }"
        @click="chosenFilter(filter)"
      >
        {{ filter.name }}
      </a>
    </div>
    <div class="frisbuy-gallery">
      <div
        :class="{
          'frisbuy-scroll-wrapper': true,
          'no-scroll-width': !isVerticalGallery && scrollWidth < 0,
        }"
        :style="{
          height:
            isVerticalGallery &&
            gallerySettings.maxCols &&
            `${
              (containerItemHeight + containerItemMargin) *
              gallerySettings.maxCols
            }px`,
        }"
        v-touch:swipe="swipeHandler"
        ref="postsScroll"
      >
        <div
          :style="{
            padding:
              isLineRowsMode &&
              scrollWidth < 0 &&
              `0 ${containerItemMargin / 2}px`,
          }"
        >
          <ul
            :class="{
              'frisbuy-gallery-posts': true,
              'frisbuy-gallery-multiline': isLineRowsMode,
              [`frisbuy-scheme-${gallerySettings.scheme}`]:
                gallerySettings.layout == 'tile' && gallerySettings.scheme,
            }"
            :style="{
              margin: `-${containerItemMargin / 2}px`,
              width: `calc(100% + ${containerItemMargin}px)`,
              height:
                !isVerticalGallery && isLineRowsMode && containerRowsHeight,
            }"
          >
            <template v-for="(post, index) in postList" :key="index">
              <li
                v-if="
                  gallerySettings.scheme &&
                  !isTablet &&
                  (index == 5 || !((index - 5) % 9))
                "
                class="frisbuy-divider"
              ></li>

              <template
                v-if="post.frisbuyPost.type === 'advertising'"
              ></template>

              <FashionListItem
                v-else
                :key="post.frisbuyPost.id"
                class="frisbuy-gallery-post"
                ref="postImage"
                :style="{
                  width: getPostItemWidth(index),
                  'min-width': '185px',
                  margin: `${containerItemMargin / 2}px`,
                  'pointer-events': `${isDragging ? 'none' : 'auto'}`,
                  'flex-shrink': 0,
                  height: '100%',
                  'aspect-ratio': '1 / 1',
                }"
                :postMedia="post.media[0]"
                :description="
                  settings.isShowDescriptionAbovePreview &&
                  post.frisbuyPost.text
                "
                @click="clickPostHandler(post, index)"
              />
            </template>
          </ul>
        </div>
      </div>
      <div
        v-if="
          gallerySettings.layout == 'arrow' &&
          ((isVerticalGallery && scrollTop > 0) || scrollWidth > 0)
        "
        :class="{
          'frisbuy-gallery-navigation': true,
          'frisbuy-big': isLineRowsMode,
        }"
      >
        <ButtonArrow
          v-if="canPrevScroll"
          @click="slideHandler(-1)"
          direction="left"
          mode="adaptive"
        />
        <span></span>
        <ButtonArrow
          v-if="canNextScroll"
          @click="slideHandler(1)"
          direction="right"
          mode="adaptive"
        />
      </div>
    </div>
    <div
      v-if="gallerySettings.branding"
      :class="[{ 'frisbuy-branding': true }, gallerySettings.branding]"
    >
      Сделано на
      <a
        :href="
          settings.brandingLink ||
          'https://www.frisbuy.ru/?utm_source=gallery&utm_medium=referral&utm_campaign=' +
            settings.customerCode
        "
        rel="nofollow"
        target="_blank"
      >
        <img
          :src="`${envDomain}/images/widget/frisbuy_logo_gray.svg`"
          alt="Frisbuy"
        />
      </a>
    </div>

    <div class="frisbuy-footer">
      <div
        :style="{ marginTop: gallerySettings.loadMore.marginTop + 'px' }"
        class="frisbuy-loadmore-button"
        v-if="
          gallerySettings.layout == 'tile' &&
          gallerySettings.loadMore.enable &&
          gallerySettings.loadMore.show
        "
        @click="loadMoreHandler"
      >
        {{ gallerySettings.loadMore.text || "Ещё" }}
      </div>
      <div
        v-if="gallerySettings.footer.html"
        v-html="gallerySettings.footer.html"
      ></div>
    </div>
    <div
      v-if="gallerySettings.guideline.html && isGuidlineOpen"
      class="frisbuy-guideline"
    >
      <div class="frisbuy-guideline-container">
        <div v-html="gallerySettings.guideline.html"></div>
      </div>
    </div>
  </div>

  <ProductPopup
    v-if="isShowPopup"
    :settings="settings"
    :mobileSettings="mobileSettings"
    :postList="postList"
    :post="currentPost"
    :postIndex="currentPostIndex"
    @changePost="
      (direction) =>
        selectPost(
          postList[currentPostIndex + direction],
          currentPostIndex + direction
        )
    "
    @close="() => closePopup()"
  />
</template>

<style scoped src="@/gallery/gallery/gallery.scss" lang="scss"></style>
<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap");

* {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-variation-settings: "slnt" 0;
}

.frisbuy-gallery-navigation {
  top: 50%;

  .frisbuy-button-arrow {
    padding: 4px 6px;
  }
}
</style>

<script>
import defaultGallery from "@/gallery/gallery/gallery.vue";
import ProductPopup from "../ProductPopup/ProductPopup.vue";
import ButtonArrow from "../components/ButtonArrow.vue";
import FashionListItem from "../components/FashionListItem.vue";

export default {
  extends: defaultGallery,

  components: { ProductPopup, ButtonArrow, FashionListItem },

  data() {
    return {
      isMouseDown: false,
      dragScrollLeft: null,
      startX: null,
      isDragging: false,
    };
  },
};
</script>
